import { clsx } from "cn";
import { type CSSProperties, forwardRef, type ReactNode } from "react";
import type { LightBoxAttachment } from "@/components/ui/lightbox/light-box-attachment";
import UnsupportedPreviewCard from "@/components/ui/lightbox/unsupported-preview-card";

type LightBoxItemProps<TAttachment extends LightBoxAttachment> = {
  item: TAttachment;
  children?: ReactNode;
  style?: CSSProperties;
};

const LightBoxItem = <TAttachment extends LightBoxAttachment>(
  props: LightBoxItemProps<TAttachment>,
  ref: any,
) => {
  const { item, children, ...restProps } = props;

  return (
    <div
      ref={ref}
      {...restProps}
      className={clsx(
        "slide",
        "max-w-full relative flex flex-col justify-center items-center m-0 min-h-75 text-text-light text-center bg-transparent",
      )}
    >
      {children ?? <UnsupportedPreviewCard item={item} />}
    </div>
  );
};

export default forwardRef(LightBoxItem);
